import {
  Airplane,
  Book,
  // Resources - Learn & Grow
  BookStack,
  BookStack as BookStackChangelog,
  Suitcase,
  BrightCrown,
  // Products - Planning Tools
  Building,
  Calculator,
  Community,
  CrownCircle,
  ProfileCircle as SettingsProfiles,
  Megaphone,
  Gamepad,
  TableRows,
  Laptop,
  // Company - Get Started
  CreditCard,
  Crown,
  EditPencil,
  Gift,
  GraphUp,
  // Solutions - By Role
  Group,
  // Resources - Support & Community
  HeadsetHelp,
  HelpCircle,
  Home,
  HotAirBalloon,
  // Company - About Us
  InfoCircle,
  Mail,
  Medal1st,
  OpenBook,
  PageStar,
  PeaceHand,
  Phone,
  ProfileCircle,
  Globe,
  UserSquare,
  // Solutions - By Company Size
  Rocket,
  User,
  UserPlus,
} from "iconoir-react";

// Type for navbar icon mapping
export interface NavbarIconMapping {
  [key: string]: {
    sections: {
      [sectionTitle: string]: {
        [itemName: string]: React.ComponentType<any>;
      };
    };
  };
}

// Icon mapping for all navbar dropdown items
export const navbarIcons: NavbarIconMapping = {
  Products: {
    sections: {
      "Planning Tools": {
        "Venue Sourcing": Building,
        Registration: UserPlus,
        "Budget Estimator": Calculator,
        "Flight Estimator": Airplane,
        "The Venue Collective": CrownCircle,
        "Create Event": EditPencil,
        "Custom Event Sites": Laptop,
        "Hotel Room Blocks": TableRows,
        "Reporting & Analytics": GraphUp,
        "Marketing Activations": Megaphone,
        Games: Gamepad,
      },
    },
  },
  Resources: {
    sections: {
      "Learn & Grow": {
        "Case Studies": BookStack,
        Blogs: EditPencil,
        Comparisons: Medal1st,
        Templates: PageStar,
        Games: Gamepad,
      },
      "Support & Community": {
        Support: HeadsetHelp,
        Community: Community,
        "Change Log": BookStackChangelog,
        Newsletter: Mail,
        FAQs: HelpCircle,
        Glossary: Book,
      },
    },
  },
  Company: {
    sections: {
      "About Us": {
        "About Nowadays": InfoCircle,
        Newsroom: OpenBook,
        Team: ProfileCircle,
        Careers: Suitcase,
      },
      "Get Started": {
        Pricing: CreditCard,
        "Partner with us": PeaceHand,
        "Referral Program": Gift,
        Contact: Phone,
        "Planner Profiles": SettingsProfiles,
      },
    },
  },
  Solutions: {
    sections: {
      "By Company Size": {
        "For Startups": Rocket,
        "For Enterprise": Globe,
      },
      "By Role": {
        "For People Teams": Group,
        "For Executive Assistants": Crown,
        "For Event Marketers": BrightCrown,
        "For Agencies": HotAirBalloon,
        "For Travel Agents": User,
        "For Hoteliers & Venues": Home,
      },
    },
  },
};

// Helper function to get icon for a specific navbar item
export const getNavbarIcon = (
  category: string,
  sectionTitle: string,
  itemName: string
): React.ComponentType<any> | null => {
  const categoryIcons = navbarIcons[category];
  if (!categoryIcons) return null;

  const sectionIcons = categoryIcons.sections[sectionTitle];
  if (!sectionIcons) return null;

  return sectionIcons[itemName] || null;
};
